module["exports"] = ["com.tr", "com", "biz", "info", "name", "gov.tr"];